import React, { useEffect, useState } from 'react';
import { Dropdown, List } from 'tea-component';
import { useLocal, useSelectArrObj } from '../../utils/customHook';

import { DataSourceSelectorProps } from './types';
import './index.scss';

const DataSourceSelector = (props: DataSourceSelectorProps) => {
  const { getLocalText } = useLocal('common');
  const {
    className,
    formValue,
    value,
    defaultValue,
    onSelect,
    onClose,
    style,
    optionsData,
    isHaveAccumulated=true
  } = props;
  const selectOptionData = useSelectArrObj(formValue?.filterValue ? formValue?.filterValue : formValue);
  let options = optionsData ? optionsData : selectOptionData;
  if(!isHaveAccumulated) {
    options = options?.filter((item: { value: string; }) => item?.value !=='accumulated');
  }
  const [selected, setSelected] = useState(
    defaultValue ?? value ?? options?.[0]?.value,
  );
  const result = options?.find((item: { value: any; }) => item.value === selected);

  const handleSelect = (value: any, callback: { (): void; (): void; }) => {
    setSelected(value);
    onSelect?.(value);
    callback?.();
  };

  useEffect(() => {
    if (!value) return;
    setSelected(value);
  }, [value]);

  return (
    <Dropdown
      className={className}
      style={style}
      button={
        <div>
          <span className="dropdown-button">{getLocalText('Dimension')} </span>
          {result?.text}
        </div>
      }
      appearance="button"
      matchButtonWidth
      clickClose={false}
      onClose={onClose}
    >
      {(close) => (
        <>
          <List type="option" style={{ maxHeight: 232 }}>
            {options?.map((item: { value: React.Key | null | undefined; text: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }) => (
              <List.Item
                key={item.value}
                selected={selected === item?.value}
                onClick={() => handleSelect(item?.value, close)}
              >
                {item?.text}
              </List.Item>
            ))}
          </List>
        </>
      )}
    </Dropdown>
  );
};

export default DataSourceSelector;
